/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import {FormattedMessage} from "react-intl";
import {InfoItem} from "./InfoItem";
import {practiceDataKeys} from "../UserDetailsUIHelpers";
import {toAbsoluteUrl} from '../../../../_metronic/_helpers';
import Empty from "./Empty";

export function PracticeData({data, className}) {
  const mapInfoItems = item => {
    const {id, key, options} = item;
    const translationKey = `userDetails-practiceData-${key}`;
    let value = data[key];
    const props = {...options, id, keyName: key, value, translationKey};

    return <InfoItem {...props} valueCustomClassName="label label-lg label-light-primary label-inline"/>
  };

  return (
    <>
      <div className={`card card-custom ${className}`}>
        <div className="card-header border-0 justify-content-start align-items-center flex-nowrap">
          <img src={toAbsoluteUrl("/media/svg/Search-blue.svg")} className="mr-3" alt="file icon"/>
          <h3 className="card-title font-weight-bolder text-dark">
            <FormattedMessage
              id="userDetails-practiceData-title"
              defaultMessage="Practice Data"
            />
          </h3>
        </div>
        <div className="card-body pt-2">
          {
            (Object.keys({...data}).length === 0)
            ? <Empty/>
            : practiceDataKeys.map(mapInfoItems)
          }
        </div>
      </div>
    </>
  );
}
